import { Route, RouterModule, Routes } from '@angular/router';
import { LoginComponent } from './login/feature/login/login.component';
import { authGuard, roleGuard } from '@equine-ui-nx/account';
import { CallbackComponent } from './callback/callback.component';
import { ResetPasswordLinkComponent } from './reset-password/feature/reset-password-link/reset-password-link.component';
import { UpdatePasswordComponent } from './reset-password/feature/update-password/update-password.component';
import { SignupComponent } from './signup/feature/signup/signup.component';
import { SignupSuccessComponent } from './signup/feature/signup-success/signup-success.component';
import { SignupVerifyComponent } from './signup/feature/signup-verify/signup-verify.component';
import { SignupSuccessVerificationComponent } from './signup/feature/signup-success-verification/signup-success-verification.component';
import { AccountNotVerifyComponent } from './login/feature/account-not-verify/account-not-verify.component';

export const routes = [
  {
    path: '',
    component: LoginComponent,
  },
  {
    path: 'login',
    component: LoginComponent,
  },
  {
    path: 'not-verify',
    component: AccountNotVerifyComponent
  },
  {
    path: 'signup',
    component: SignupComponent,
  },
  {
    path: 'signup-success',
    component: SignupSuccessComponent,
  },
  {
    path: 'verify',
    component: SignupVerifyComponent,
  },
  {
    path: 'verify-success',
    component: SignupSuccessVerificationComponent,
  },
  {
    path: 'resetPassword',
    component: ResetPasswordLinkComponent,
  },
  {
    path: 'passwordreset/:token',
    component: UpdatePasswordComponent,
  },
  {
    path: 'callback',
    component: CallbackComponent
  }
];

// export const accountRoutes: Route[] = [
//   {
//     path: 'account',
//     canActivate: [authGuard],
//     // data: { authorizedRole: ['riders', 'admin'] },
//     loadChildren: () =>
//       import('@equine-ui-nx/account').then((mod) => mod.routes),
//   },
// ];
